import React from "react"
import { Redirect }  from "react-router-dom"
import axios from "axios";
import Logo from "./assets/logo.png";
import { login as API_URL } from "./config/api";

const postUrlLogin = API_URL;

class Login extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            name                : "",
            email               : "",
            password            : "",
            fireRedirect        : false,
            fireLoginError      : false,
            resetModal          : false,
            request_send        : ""
        };
        this.getValidationState  = this.getValidationState.bind(this);
        this.getValidateSubmit   = this.getValidateSubmit.bind(this);
        this.handleLoginSubmit   = this.handleLoginSubmit.bind(this);
        this.handleInputChange   = this.handleInputChange.bind(this);
    }
    
    handleInputChange(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;
        this.setState({
            [name]: value,
            fireLoginError : false
        });
    }
    getValidationState(data){
        if ( data === "email" ){
            var $email = this.state[data];
            if ( $email.length && /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test($email) ){
                return "success"
            } else {
                return "error"
            }
        } else if ( data === "password" ){
            if ( this.state[data].length ){
                return "success"
            } else {
                return "error"
            }
        } else {
            return "success"
        }
    }

    getValidateSubmit(data){
        var $self = this;
        var $s = true;
        Object.keys(data).map(function(key) {
            if ( $self.getValidationState(key) !== "success" ){
                $s = false
            }
            return $s
        });
        return $s
    }

    handleLoginSubmit(event) {
        event.preventDefault();

        var $self = this;
        var data = {
            email               : this.state.email,
            password            : this.state.password,
        };
        if ( this.getValidateSubmit(data) ){
        var qs = require("qs");
        $self.setState({
            request_send : " hide",
            fireLoginError : false
        })
        axios.post(postUrlLogin, qs.stringify(data))
            .then(function (response) {
                if ( response.data["status"] === "login" ){
                    localStorage.setItem("api_token", response.data["api_token"]);
                    localStorage.setItem("name", response.data["name"]);
                    localStorage.setItem("email", response.data["email"]);
                    $self.props.setSession(true)
                } else if ( response.data["status"] === "error" ){
                    $self.setState({ fireLoginError : true });
                }
                $self.setState({ request_send: "" });
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
  
  render(){
    return(
        <div className="container login">
            <br />
            <div className='header-form'>
                <img src={Logo} />
            </div>
            <div className="card card-container">
                <form onSubmit={this.handleLoginSubmit} className="form-signin">
                <br />
                    <span id="reauth-email" className="reauth-email"></span>
                    <p className="input_title">Email</p>
                    <input type="email" id="inputEmail" name="email" className="login_box" value={this.state.emai} placeholder="user01@IceCode.com" onChange={this.handleInputChange} required autoFocus />
                    <p className="input_title">Password</p>
                    <input type="password" id="inputPassword" name="password" className="login_box" value={this.state.password} onChange={this.handleInputChange} placeholder="******" required />
                    <div id="remember" className="checkbox">
                        <label>
                            
                        </label>
                    </div>
                    <button className={"btn btn-lg btn-primary " + this.state.request_send } type="submit">INICIAR SESIÓN</button>
                    <span className={"error-login " + (this.state.fireLoginError === true ? "" : "hide")}>
                        El usuario y/o contraseña no son válidos
                    </span>
                </form>
            </div>
        </div>
    )
  }
};

export default Login


// WEBPACK FOOTER //
// ./src/Frontend/Login.js